import { Component } from '@angular/core';
import { LoadingController, NavController, IonicPage } from 'ionic-angular';

import { SubscriptionService } from '../../providers/subscription-service';
import { PodcastService } from '../../providers/podcast-service';

import { API_TIMEOUT } from '../../providers/config';

@IonicPage()
@Component({
  selector: 'page-explore',
  templateUrl: 'explore.html'
})

export class ExplorePage {
  keywords: any;
  results: any[];
  subscriptions: any[];

  constructor(
    public navCtrl: NavController,
    public loadingCtrl: LoadingController,
    public subscriptionService: SubscriptionService,
    public podcastService: PodcastService
  ) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ExplorePage');
    this.reloadData().then();
  }

  // reload list data
  reloadData() {
    return new Promise(resolve => {
      // reloading subs
      this.subscriptionService.podcasts().subscribe((podcasts: any) => {
        this.subscriptions = podcasts;
      });
      // reloading search results if needed
      if (this.keywords !== undefined) {
        this.podcastService.search(this.keywords).subscribe((podcasts: any[]) => {
          this.results = podcasts;
        });
      }
    });
  }

  search($event) {
    // check if enough chars to send search
    if ((this.keywords === undefined) || (this.keywords.length <= 2)) {
      return alert('Please enter longer keywords for your search.');
    }
    let loader = this.loadingCtrl.create({
      content: 'Searching for podcasts...',
      duration: API_TIMEOUT
    });
    loader.present();
    // looking for podcast
    this.podcastService.search(this.keywords).subscribe((podcasts: any[]) => {
      this.results = podcasts;
      loader.dismiss();
    });
    $event.stopPropagation();
  }

  isSubbed(podcast) {
    var result = false;
    // check on-the-fly if user is subbed to podcast from list
    this.subscriptions.forEach((subscription) => {
      if (subscription._id === podcast._id) {
        result = true;
      }
    });
    return result;
    // return (this.subscriptions.indexOf(podcast) !== -1) ? true : false;
  }

  subscribe($event, podcast) {
    let loader = this.loadingCtrl.create({
      content: 'Subcribing...',
      duration: API_TIMEOUT
    });
    loader.present();
    const podcastId = podcast._id;
    // subscribe to podcast
    this.subscriptionService.subscribe(podcastId).subscribe((success: Boolean) => {
      if (success) {
        // go back to list
        loader.setContent('Great success!');
        // this.navCtrl.pop();
        this.reloadData().then();
        loader.dismiss();
      } else {
        // display error
        loader.setContent('Oops! Error or could you already subcribed to this podcast?');
        setTimeout(() => {
          loader.dismiss();
        }, 3000);
      }
    });
    $event.stopPropagation();
  }

  unsubscribe($event, podcast) {
    let loader = this.loadingCtrl.create({
      content: 'Unsubcribing...',
      duration: API_TIMEOUT
    });
    loader.present();
    const podcastId = podcast._id;
    // subscribe to podcast
    this.subscriptionService.unsubscribe(podcastId).subscribe((success: Boolean) => {
      if (success) {
        // go back to list
        loader.setContent('Great success!');
        // this.navCtrl.pop();
        this.reloadData().then();
        loader.dismiss();
      } else {
        // display error
        loader.setContent('Oops! Error or could you already subcribed to this podcast?');
        setTimeout(() => {
          loader.dismiss();
        }, 3000);
      }
    });
    $event.stopPropagation();
  }
}



// WEBPACK FOOTER //
// ./src/pages/explore/explore.ts